<template>
  <div>
    <b-card
      v-if="Object.keys(data).length > 0"
      no-body
      class="border-primary mb-0"
    >
      <b-card-header class="mb-0 pl-1 pr-1 pt-1 p-0">
        <b-card-title>
          <h3>
            {{ data.apenom }}

            <small
              v-if="
                data.sobrenombre != null &&
                  data.sobrenombre != ''
              "
              class="text-secondary"
            >[ {{ data.sobrenombre }} ]</small>
          </h3>
        </b-card-title>
        <b-card-title class="text-danger">
          <contract-balance
            :key="data.idcontrato"
            :idcontrato="data.idcontrato"
          />
        </b-card-title>
      </b-card-header>
      <b-row class="ml-1 mt-0">
        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :src="data.avatar"
              :text="avatarText(data.apenom)"
              size="100px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <div class="mb-0">
                <h4
                  :class="`text-${data.contrato_estado.class} m-0`"
                >
                  {{ data.codigo }}
                </h4>
                <a
                  :href="`mailto:${data.email}`"
                  class="card-text"
                >{{ data.email }}</a>
              </div>
              <div class="d-flex flex-wrap">
                <b-button :variant="data.contrato_estado.class">
                  {{ data.codigo }} -
                  {{ data.contrato_estado.estado }}
                </b-button>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1">
            <contract-buttons
              :data="data"
              @reload="reload()"
            />
          </div>

          <ul class="list-unstyled my-1">
            <li class="text-primary">
              <small class="text-muted w-100">Localidad</small>
              <br>
              <span
                v-if="data.localidad != null"
              >{{ data.localidad.localidad }} -
              </span>
              <span v-if="data.sector != null">{{
                data.sector.sector
              }}</span>
            </li>
            <li v-if="data.direccion != ''">
              <small class="text-muted w-100">Dirección</small>
              <br>
              {{ data.direccion }}
            </li>
            <li v-if="data.referencia != ''">
              <small class="text-muted w-100">Referencia</small>
              <br>
              {{ data.referencia }}
            </li>
          </ul>
        </b-col>

        <!-- Right Col: Table -->
        <b-col
          cols="12"
          xl="6"
        >
          <ul class="list-unstyled my-1">
            <li class="mb-1">
              <contract-values :data="data" />
            </li>
            <li v-if="data.sobrenombre != null">
              <feather-icon
                icon="UserIcon"
                class="mr-85"
                size="15"
              />
              <small class="text-muted w-100">Alias</small>
              <br>
              {{ data.sobrenombre }}
            </li>
            <li v-if="data.ruc != ''">
              <feather-icon
                icon="UserIcon"
                class="mr-85"
              />
              <small class="text-muted w-100">NUI</small>
              <br>
              {{ data.ruc }}
            </li>
            <li v-if="data.telefono != ''">
              <feather-icon
                icon="PhoneIcon"
                class="mr-85"
              />
              <small class="text-muted w-100">Telefono</small>
              <br>
              {{ data.telefono }}
            </li>
            <li>
              <feather-icon
                icon="CheckIcon"
                class="mr-85"
              />
              <small class="text-muted w-100">Fecha</small>
              <br>
              {{ data.fecha_contrato | dateFormat }}
            </li>
            <li v-if="data.comprobante != null">
              <feather-icon
                icon="FileTextIcon"
                class="mr-85"
              />
              <small class="text-muted w-100">Comprobante</small>
              <br>
              {{ data.comprobante.comprobante }}
            </li>
          </ul>
          <div class="mt-0 mb-1">
            <b-badge
              v-if="data.op_descuento"
              variant="danger"
            >
              Tarifa Especial: {{ data.descuento_v }} (
              {{ data.descuento_p }}% )
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { avatarText } from "@core/utils/filter"
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BRow,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import ContractBalance from "./ContractBalance.vue"
import ContractButtons from "./ContractButtons.vue"
import ContractValues from "./ContractValues.vue"

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    ContractButtons,
    ContractValues,
    ContractBalance,
  },
  directives: {
    Ripple,
  },
  filters: {
    dateFormat (string) {
      return string.split("-").reverse().join("/")
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
  data() {
    return {
    }
  },
  created() {},
  methods: {
    reload() {
      this.$emit("reload")
    },
  },
}
</script>

<style></style>
